import React from 'react';
import { IconProps } from '../types';

export const BusinessPlansIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_8890_7589)">
            <path
                d="M23.9191 2L15.6667 10.2525L11.0404 5.62623C10.6499 5.2357 10.0168 5.2357 9.62623 5.62623L2.95956 12.2929C2.56904 12.6834 2.56904 13.3166 2.95956 13.7071C3.35008 14.0976 3.98325 14.0976 4.37377 13.7071L10.3333 7.74755L14.9596 12.3738C15.3501 12.7643 15.9832 12.7643 16.3738 12.3738L25.3333 3.41421V7.66667C25.3333 8.21895 25.781 8.66667 26.3333 8.66667C26.8856 8.66667 27.3333 8.21895 27.3333 7.66667V1C27.3333 0.744078 27.2357 0.488155 27.0404 0.292893C26.9446 0.197017 26.8341 0.124678 26.7161 0.0758787C26.5982 0.0269854 26.4689 0 26.3333 0H19.6667C19.1144 0 18.6667 0.447715 18.6667 1C18.6667 1.55228 19.1144 2 19.6667 2H23.9191Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25 12C24.4477 12 24 12.4477 24 13V30.3333C24 30.8856 24.4477 31.3333 25 31.3333H30.3333C30.8856 31.3333 31.3333 30.8856 31.3333 30.3333V13C31.3333 12.4477 30.8856 12 30.3333 12H25ZM26 29.3333V14H29.3333V29.3333H26Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 18.3333C12 17.781 12.4477 17.3333 13 17.3333H18.3333C18.8856 17.3333 19.3333 17.781 19.3333 18.3333V30.3333C19.3333 30.8856 18.8856 31.3333 18.3333 31.3333H13C12.4477 31.3333 12 30.8856 12 30.3333V18.3333ZM14 19.3333V29.3333H17.3333V19.3333H14Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 23.6667C0 23.1144 0.447715 22.6667 1 22.6667H6.33333C6.88562 22.6667 7.33333 23.1144 7.33333 23.6667V30.3333C7.33333 30.8856 6.88562 31.3333 6.33333 31.3333H1C0.447715 31.3333 0 30.8856 0 30.3333V23.6667ZM2 24.6667V29.3333H5.33333V24.6667H2Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_8890_7589">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
